import { Injectable, NgZone } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Router } from '@angular/router';
import { TreeNodeService } from '../shared/services/treedata.service';
import { ApiService } from './api.service';
import { NgxIndexedDBService } from 'ngx-indexed-db';

@Injectable({
  providedIn: 'root'
})
export class DesignService {
  singles: any;
  couples: any;
  coupleinfos = {};
  nodeinfos = {};
  filtered_singles: any;
  filtered_couples: any;

  constructor(
    public afs: AngularFirestore,   // Inject Firestore service
    public afAuth: AngularFireAuth, // Inject Firebase auth service
    private ApiService: ApiService,
    private treeService: TreeNodeService,
    public router: Router,
    public ngZone: NgZone,// NgZone service to remove outside scope warning
    private dbService: NgxIndexedDBService
  ) { }


  saveDesign(doc) {
    const userID = JSON.parse(localStorage.getItem('user')).uid;
    doc.uid = userID;
    doc.deleted = false
    return this.afs.collection('designs').add(doc);
  }

  deleteDesign(id) {
    return this.afs.collection('designs').doc(id).set({ deleted: true }, { merge: true })
  }

  updateDesign(id, doc) {
    console.log(doc)
    doc.deleted = false
    return this.afs.collection('designs').doc(id).set(doc, { merge: true })
  }

  getDesigns() {
    const userID = JSON.parse(localStorage.getItem('user')).uid;
    return this.afs.collection('designs', ref => ref.where('uid', '==', userID).where('deleted', '!=', true)).snapshotChanges();
  }

  // saveWizardDesign() {
  // const settingsObject = {
  //   backOpacity: 0.3,
  //   background: "assets/image/portrait/37.svg",
  //   birthSetting: "block",
  //   borderColor: "#b6bec8",
  //   borderRadius: 400,
  //   borderWidth: 40,
  //   deathSetting: "block",
  //   deleted: false,
  //   design_name: "wizard 4 stående",
  //   direction: "1",
  //   empty_node_setting: "none",
  //   femaleNodeColor: "#b6bec8",
  //   flag_setting: "HIDE",
  //   global_padding: "5",
  //   maleNodeColor: "#b6bec8",
  //   manColor: "#000",
  //   marriageSetting: "block",
  //   maxGeneration: "10",
  //   name_text_align: "middle",
  //   nodeOpacity: 1,
  //   papertype: "A0",
  //   profile_setting: "SHOW",
  //   text_align: "middle",
  //   treeHeight: "47679",
  //   treeWidth: "67408",
  //   tree_height: "47679",
  //   tree_width: "67408",
  //   type: "single",
  //   warning_setting: "HIDE",
  //   womanColor: "#000",
  // };

  // return this.afs.collection('wizard_designs').add(settingsObject);
  // }

  getWizardDesigns() {
    const userID = JSON.parse(localStorage.getItem('user')).uid;
    return this.afs.collection('wizard_designs', ref => ref).snapshotChanges();
  }

  getDeltedDesigns() {
    const userID = JSON.parse(localStorage.getItem('user')).uid;
    return this.afs.collection('designs', ref => ref.where('uid', '==', userID).where('deleted', '==', true)).snapshotChanges();
  }

  async getOrderdDesignById(id) {
    let reqdesign = await this.afs.collection('orders').doc(id).get().toPromise()
    let design: any = reqdesign.data();
    this.ApiService.getGedcom(design.gedcom_id).then((gedcom: any) => {
      this.singles = gedcom.indis;
      for (let index = 0; index < this.singles.length; index++) {
        const element = this.singles[index];
      }
      this.couples = gedcom.fams;
      this.couples.forEach(data => {
        this.coupleinfos[data.id] = data;
      });
      this.singles.forEach(data => {
        this.nodeinfos[data.id] = data;
        this.nodeinfos[data.id]['country'] = ""
        this.nodeinfos[data.id]['avatar_type'] = "sample"
        this.nodeinfos[data.id]['c_flag'] = ""
        this.nodeinfos[data.id]['father'] = (data['famc'] && this.coupleinfos[data['famc']]['husb']) ? this.coupleinfos[data['famc']]['husb'] : "";
        this.nodeinfos[data.id]['mother'] = (data['famc'] && this.coupleinfos[data['famc']]['wife']) ? this.coupleinfos[data['famc']]['wife'] : "";
        this.nodeinfos[data.id]['marriage'] = [];
        this.nodeinfos[data.id]['wife'] = [];
        this.nodeinfos[data.id]['husb'] = [];
        this.nodeinfos[data.id]['child_info'] = [];
        this.nodeinfos[data.id]['avatar_setting'] = 'SHOW';
        this.nodeinfos[data.id]['note'] = '';
        this.nodeinfos[data.id]['warning'] = false;

        if (data['fams']) {
          data['fams'].forEach(item => {
            this.nodeinfos[data.id]['marriage'] = { [item]: this.coupleinfos[item].marriage };
            if (data['sex'] == 'M') {
              if (this.coupleinfos[item].wife) this.nodeinfos[data.id]['wife'].push(this.coupleinfos[item].wife);
            }
            else {
              if (this.coupleinfos[item].husb) this.nodeinfos[data.id]['husb'].push(this.coupleinfos[item].husb);
            }
            this.coupleinfos[item].children.forEach(child => {
              this.nodeinfos[data.id]['child_info'].push(child);
            })
          })
        }
        else {
          this.nodeinfos[data.id]['wife'] = [];
          this.nodeinfos[data.id]['child_info'] = [];
        }
      });

      let temp1 = this.treeService.dateString(this.nodeinfos);

      this.filtered_singles = this.singles;
      this.filtered_couples = this.couples;
      localStorage.setItem("background", design.background)
      localStorage.setItem("nodeinfos", JSON.stringify(temp1))
      localStorage.setItem("coupleinfos", JSON.stringify(this.coupleinfos))
      localStorage.setItem("type", design.type);
      localStorage.setItem("id", design.id);
      localStorage.setItem("papertype", design.papertype);
      localStorage.setItem("direction", design.direction);
      localStorage.setItem("maxGeneration", design.maxGeneration);
      localStorage.setItem("tree_width", design.tree_width);
      localStorage.setItem("tree_height", design.tree_height);
      localStorage.setItem('manColor', design.manColor);
      localStorage.setItem('womanColor', design.womanColor);
      localStorage.setItem('borderColor', design.borderColor);
      localStorage.setItem('maleNodeColor', design.maleNodeColor);
      localStorage.setItem('femaleNodeColor', design.femaleNodeColor);
      localStorage.setItem('cornerRound', design.cornerRound);
      localStorage.setItem('borderWidth', design.borderWidth)
      localStorage.setItem('backOpacity', design.backOpacity);
      localStorage.setItem('nodeOpacity', design.nodeOpacity);
      localStorage.setItem('tree_width', design.tree_width);
      localStorage.setItem('tree_height', design.tree_height);
      localStorage.setItem('empty_node_setting', design.empty_node_setting);
      localStorage.setItem('text_align', design.text_align);
      localStorage.setItem('name_text_align', design.name_text_align);
      localStorage.setItem('birth_setting', design.birth_setting);
      localStorage.setItem('marriage_setting', design.merrage_setting);
      localStorage.setItem('death_setting', design.death_setting);
      localStorage.setItem('flag_setting', design.flag_setting);
      localStorage.setItem('profile_setting', design.profile_setting);
      localStorage.setItem('warning_setting', design.warning_setting);
      localStorage.setItem('global_padding', design.global_padding);
      localStorage.setItem('doc_id', id)
    });
  }


  goToDesign(design, id) {
    this.ApiService.getGedcom(design.gedcom_id).then((gedcom: any) => {
      this.singles = gedcom.indis;
      for (let index = 0; index < this.singles.length; index++) {
        const element = this.singles[index];
      }
      this.couples = gedcom.fams;
      this.couples.forEach(data => {
        this.coupleinfos[data.id] = data;
      });
      this.singles.forEach(data => {
        this.nodeinfos[data.id] = data;
        this.nodeinfos[data.id]['country'] = ""
        this.nodeinfos[data.id]['avatar_type'] = "sample"
        this.nodeinfos[data.id]['c_flag'] = ""
        this.nodeinfos[data.id]['father'] = (data['famc'] && this.coupleinfos[data['famc']]['husb']) ? this.coupleinfos[data['famc']]['husb'] : "";
        this.nodeinfos[data.id]['mother'] = (data['famc'] && this.coupleinfos[data['famc']]['wife']) ? this.coupleinfos[data['famc']]['wife'] : "";
        this.nodeinfos[data.id]['marriage'] = [];
        this.nodeinfos[data.id]['wife'] = [];
        this.nodeinfos[data.id]['husb'] = [];
        this.nodeinfos[data.id]['child_info'] = [];
        this.nodeinfos[data.id]['avatar_setting'] = 'SHOW';
        this.nodeinfos[data.id]['note'] = '';
        this.nodeinfos[data.id]['warning'] = false;

        if (data['fams']) {
          data['fams'].forEach(item => {
            this.nodeinfos[data.id]['marriage'] = { [item]: this.coupleinfos[item].marriage };
            if (data['sex'] == 'M') {
              if (this.coupleinfos[item].wife) this.nodeinfos[data.id]['wife'].push(this.coupleinfos[item].wife);
            }
            else {
              if (this.coupleinfos[item].husb) this.nodeinfos[data.id]['husb'].push(this.coupleinfos[item].husb);
            }
            this.coupleinfos[item].children.forEach(child => {
              this.nodeinfos[data.id]['child_info'].push(child);
            })
          })
        }
        else {
          this.nodeinfos[data.id]['wife'] = [];
          this.nodeinfos[data.id]['child_info'] = [];
        }
      });

      let temp1 = this.treeService.dateString(this.nodeinfos);

      this.filtered_singles = this.singles;
      this.filtered_couples = this.couples;

      let nodeinfos = JSON.stringify(temp1)
      let coupleinfos = JSON.stringify(this.coupleinfos)

      this.dbService.deleteByKey('nodes', 1).subscribe((status) => {
        console.log('Deleted?:', status);
      }, err => console.log(err));

      this.dbService
        .add('nodes', {
          id: 1,
          nodeinfos: nodeinfos,
          coupleinfos: coupleinfos,
        })
        .subscribe((key) => {
          console.log('key: ', key);
        });
      this.dbService.getByKey('nodes', 1).subscribe((nodes: any) => {
      }, err => console.log(err));

      localStorage.setItem("background", design.background)
      localStorage.setItem("type", design.type);
      localStorage.setItem("id", design.id);
      localStorage.setItem("papertype", design.papertype);
      localStorage.setItem("direction", design.direction);
      localStorage.setItem("maxGeneration", design.maxGeneration);
      localStorage.setItem("tree_width", design.tree_width);
      localStorage.setItem("tree_height", design.tree_height);
      localStorage.setItem('manColor', design.manColor);
      localStorage.setItem('womanColor', design.womanColor);
      localStorage.setItem('borderColor', design.borderColor);
      localStorage.setItem('maleNodeColor', design.maleNodeColor);
      localStorage.setItem('femaleNodeColor', design.femaleNodeColor);
      localStorage.setItem('cornerRound', design.cornerRound);
      localStorage.setItem('borderWidth', design.borderWidth)
      localStorage.setItem('backOpacity', design.backOpacity);
      localStorage.setItem('nodeOpacity', design.nodeOpacity);
      localStorage.setItem('tree_width', design.tree_width);
      localStorage.setItem('tree_height', design.tree_height);
      localStorage.setItem('empty_node_setting', design.empty_node_setting);
      localStorage.setItem('text_align', design.text_align);
      localStorage.setItem('name_text_align', design.name_text_align);
      localStorage.setItem('birth_setting', design.birth_setting);
      localStorage.setItem('marriage_setting', design.merrage_setting);
      localStorage.setItem('death_setting', design.death_setting);
      localStorage.setItem('flag_setting', design.flag_setting);
      localStorage.setItem('profile_setting', design.profile_setting);
      localStorage.setItem('warning_setting', design.warning_setting);
      localStorage.setItem('global_padding', design.global_padding);
      localStorage.setItem('doc_id', id)
      this.router.navigateByUrl('/dashboard/main');
    });
  }

}
